<template>
	<el-row class="mainOnebox">
		<!-- 标题 -->
		<el-row class="mainOnebox_title">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>PRODUCT</el-breadcrumb-item>
				<el-breadcrumb-item>Accessories</el-breadcrumb-item>
			</el-breadcrumb>
		</el-row>
		<!-- 内容 -->
		<el-row class="mainOnebox_main">
			<div class="mainOnebox_main_list_remove" v-for="(item,i) in imgdata" :key="i" @click="routelist(i)" @mouseenter="changeActive($event)" @mouseleave="removeActive($event)">
				<img :src="item.url">
				<span class="mainOnebox_main_list_name">{{item.title}}</span>
			</div>
			<div class="mainOnebox_main_list_none"></div>
			<div class="mainOnebox_main_list_none"></div>
		</el-row>
	</el-row>
</template>

<script>
	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {
				imgdata: [
					{url: require('@/assets/image/productType/Accessories/HZ-A0152.jpg'),title: 'HZ-A0152',list1:'As picture / Customized',list2:'Stainless steel + Nylon',list3:'As picture / Customized',list4:'Matter surface',list5:'To twisting',list6:'Hezone Tile',list7:'Hospital, bathroom, nursing home and hotel for support',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A0153.jpg'),title: 'HZ-A0153',list1:'As picture / Customized',list2:'Stainless steel + Nylon',list3:'As picture / Customized',list4:'Matter surface',list5:'To twisting',list6:'Hezone Tile',list7:'Hospital, bathroom, nursing home and hotel for support',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A0155.jpg'),title: 'HZ-A0155',list1:'As picture / Customized',list2:'Stainless steel',list3:'As picture / Customized',list4:'Brushed',list5:'To twisting',list6:'Hezone Tile',list7:'Hospital, bathroom, nursing home and hotel for support',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A0212.jpg'),title: 'HZ-A0212',list1:'As picture / Customized',list2:'PE, PU',list3:'As picture / Customized',list4:'Reflection',list5:'Injection',list6:'Hezone Tile',list7:'Used for warning in parking lots, road and etc.',list8:'No',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A0223.jpg'),title: 'HZ-A0223',list1:'As picture / Customized',list2:'PE, PU',list3:'As picture / Customized',list4:'Reflection',list5:'Injection',list6:'Hezone Tile',list7:'Used for warning in parking lots, road and etc.',list8:'No',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A0505.jpg'),title: 'HZ-A0505',list1:'As picture / Customized',list2:'Aluminum',list3:'As picture / Customized',list4:'Matter surface',list5:'Molding',list6:'Hezone Tile',list7:'Used as a reminder in washroom',list8:'No',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A1008.jpg'),title: 'HZ-A1008',list1:'As picture / Customized',list2:'Stainless steel',list3:'As picture / Customized',list4:'Original',list5:'Bending ',list6:'Hezone Tile',list7:'Used for fastening',list8:'No',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A1009.jpg'),title: 'HZ-A1009',list1:'As picture / Customized',list2:'PU, PE, PP',list3:'As picture / Customized',list4:'Rough',list5:'Injection',list6:'Hezone Tile',list7:'Used for fastening',list8:'No',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A1010.jpg'),title: 'HZ-A1010',list1:'As picture / Customized',list2:'Stainless steel',list3:'As picture / Customized',list4:'Original',list5:'Molding',list6:'Hezone Tile',list7:'Used for fastening',list8:'No',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A1252.jpg'),title: 'HZ-A1252',list1:'As picture / Customized',list2:'Stainless steel',list3:'As picture / Customized',list4:'Customerized',list5:'Molding',list6:'Hezone Tile',list7:'Used for fastening',list8:'No',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A1255.jpg'),title: 'HZ-A1255',list1:'As picture / Customized',list2:'Stainless steel',list3:'As picture / Customized',list4:'Customerized',list5:'Molding',list6:'Hezone Tile',list7:'Used for fastening',list8:'No',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/Accessories/HZ-A1515.jpg'),title: 'HZ-A1515',list1:'As picture / Customized',list2:'Plastic',list3:'As picture / Customized',list4:'Customerized',list5:'Molding',list6:'Hezone Tile',list7:'Used for anti-skidding',list8:'R10',list9:'Direct Manufacturer',},
				],
				imgDatalis:6,//是从哪个分类进来的
			}
		},
		created() {
			this.setSessionData()
		},
		methods: {
			routelist(i) {
				this.$router.push({
					path: '/productList',
					query: {
						id: i,
						imgDataIndex:this.imgDatalis,//是从哪个分类进来的
					}
				})
			},
			changeActive(e) {
				e.currentTarget.className = 'mainOnebox_main_list';
			},
			removeActive(e) {
				e.currentTarget.className = 'mainOnebox_main_list_remove';
			},
			setSessionData(){
				sessionStorage.setItem('imgData'+this.imgDatalis,JSON.stringify(this.imgdata))
			}
		},

	}
</script>

<style lang="less" scoped>
	@vw: 19.2vw;

	.mainOnebox {
		background: url(~@/assets/image/home/home_bg1.jpg);

		.mainOnebox_title {
			width: 100%;
			padding-left: 7vw;
			margin: 0 auto;
			title-align: center;
			margin-top: 80/@vw;
			margin-bottom: 50/@vw;

			/deep/.el-breadcrumb {
				font-size: 24/@vw;
			}
		}

		.mainOnebox_main {
			max-width: 1530px;
			margin: 0 auto;
			height: auto;
			padding-bottom: 100/@vw;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;

			.mainOnebox_main_list {
				width: 350px;
				height: 350px;
				margin: 1vh 1.5vw;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 350px;
					height: 350px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					position: absolute;
					bottom: 0;
					height: 100%;
					width: 100%;
					font-weight: 700;
					color: #fafafa;
					width: 100%;
					z-index: 999;
					left: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					background-color: #000000;
					background-color: rgba(51, 51, 51, 0.5);
					font-size: 20px;
					transition: all 0.5s ease 0s;
					cursor: pointer;
				}
			}
			.mainOnebox_main_list_remove {
				width: 350px;
				height: 350px;
				margin: 1vh 1.5vw;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 350px;
					height: 350px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					display: none;
				}
			}
			.mainOnebox_main_list_none {
				width: 350px;
				margin: 1vh 1.5vw;
				height: 0px;
			}
		}
	}
</style>
